import { forwardRef, type ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

const TableCell = forwardRef<HTMLTableCellElement, ComponentProps<'td'>>(
	({ className, ...props }, ref) => (
		<td
			{...props}
			ref={ref}
			className={twMerge(
				'overflow-hidden text-ellipsis whitespace-nowrap px-4 align-middle leading-normal tracking-wide text-dm-white',
				className
			)}
		/>
	)
);

TableCell.displayName = 'TableCell';

export default TableCell;
